export const horoscopeName_es = ['Aries', 'Tauro', 'Géminis', 'Cáncer', 'Leo', 'Virgo', 'Libra', 'Escorpio', 'Sagitario', 'Capricornio', 'Acuario', 'Piscis']
export const horoscopeDate_es = ['Marzo 21 - Abr 19', 'Abr 20 - Mayo 20', 'Mayo 21 - Jun 20', 'Jun 21 - Jul 22', 'Jul 23 - Agosto 22', 'Agosto 23 - sept 22', 'sept 23 - Oct 22', 'Oct 23 - Nov 21', 'Nov 22 - Dic 21', 'Dic 22 - Enero 19', 'Enero 20 - Feb 18', 'Feb 19 - Marzo 20']
export const ratings_es = {
    Aries: {
        love: {
            0: 5,
            1: 2,
            2: 3,
            3: 5,
            4: 2,
            5: 4,
            6: 3,
            7: 5,
            8: 4,
            9: 2
        },
        mood: {
            0: 3,
            1: 4,
            2: 4,
            3: 2,
            4: 3,
            5: 4,
            6: 2,
            7: 4,
            8: 3,
            9: 2

        },
        money: {
            0: 4,
            1: 3,
            2: 2,
            3: 2,
            4: 4,
            5: 3,
            6: 2,
            7: 4,
            8: 2,
            9: 5

        },
        career: {
            0: 5,
            1: 4,
            2: 2,
            3: 1,
            4: 2,
            5: 3,
            6: 4,
            7: 5,
            8: 4,
            9: 3

        }
    },
    Tauro: {
        love: {
            0: 3,
            1: 4,
            2: 4,
            3: 5,
            4: 3,
            5: 4,
            6: 2,
            7: 4,
            8: 3,
            9: 2

        },
        mood: {
            0: 5,
            1: 2,
            2: 3,
            3: 5,
            4: 2,
            5: 4,
            6: 3,
            7: 5,
            8: 4,
            9: 2

        },
        money: {
            0: 5,
            1: 4,
            2: 2,
            3: 4,
            4: 2,
            5: 3,
            6: 4,
            7: 5,
            8: 4,
            9: 3

        },
        career: {
            0: 4,
            1: 3,
            2: 2,
            3: 5,
            4: 4,
            5: 3,
            6: 2,
            7: 4,
            8: 2,
            9: 5
        }
    },
    Géminis: {
        love: {
            0: 5,
            1: 4,
            2: 4,
            3: 3,
            4: 5,
            5: 2,
            6: 4,
            7: 3,
            8: 4,
            9: 2

        },
        mood: {
            0: 4,
            1: 3,
            2: 2,
            3: 4,
            4: 3,
            5: 4,
            6: 5,
            7: 4,
            8: 4,
            9: 2

        },
        money: {
            0: 4,
            1: 3,
            2: 2,
            3: 4,
            4: 3,
            5: 4,
            6: 5,
            7: 2,
            8: 1,
            9: 2

        },
        career: {
            0: 4,
            1: 5,
            2: 2,
            3: 3,
            4: 2,
            5: 3,
            6: 5,
            7: 3,
            8: 2,
            9: 5

        }
    },
    Cáncer: {
        love: {
            0: 4,
            1: 3,
            2: 2,
            3: 5,
            4: 4,
            5: 3,
            6: 2,
            7: 4,
            8: 2,
            9: 5
        },
        mood: {
            0: 5,
            1: 4,
            2: 2,
            3: 4,
            4: 2,
            5: 3,
            6: 4,
            7: 5,
            8: 4,
            9: 3
        },
        money: {
            0: 5,
            1: 2,
            2: 3,
            3: 5,
            4: 2,
            5: 4,
            6: 3,
            7: 5,
            8: 4,
            9: 2

        },
        career: {
            0: 3,
            1: 4,
            2: 4,
            3: 5,
            4: 3,
            5: 4,
            6: 2,
            7: 4,
            8: 3,
            9: 2

        }
    },
    Leo: {
        love: {
            0: 3,
            1: 4,
            2: 5,
            3: 5,
            4: 3,
            5: 2,
            6: 3,
            7: 5,
            8: 1,
            9: 3

        },
        mood: {
            0: 4,
            1: 3,
            2: 5,
            3: 4,
            4: 2,
            5: 1,
            6: 4,
            7: 5,
            8: 2,
            9: 1

        },
        money: {
            0: 5,
            1: 2,
            2: 3,
            3: 5,
            4: 4,
            5: 2,
            6: 1,
            7: 2,
            8: 5,
            9: 4

        },
        career: {
            0: 3,
            1: 4,
            2: 5,
            3: 2,
            4: 4,
            5: 2,
            6: 3,
            7: 5,
            8: 1,
            9: 3

        }
    },
    Virgo: {
        love: {
            0: 4,
            1: 3,
            2: 5,
            3: 4,
            4: 2,
            5: 1,
            6: 5,
            7: 3,
            8: 2,
            9: 1

        },
        mood: {
            0: 3,
            1: 4,
            2: 5,
            3: 2,
            4: 1,
            5: 2,
            6: 3,
            7: 2,
            8: 2,
            9: 1

        },
        money: {
            0: 2,
            1: 3,
            2: 4,
            3: 2,
            4: 2,
            5: 2,
            6: 5,
            7: 3,
            8: 5,
            9: 4

        },
        career: {
            0: 3,
            1: 2,
            2: 2,
            3: 1,
            4: 2,
            5: 2,
            6: 3,
            7: 2,
            8: 3,
            9: 1

        }
    },
    Libra: {
        love: {
            0: 3,
            1: 4,
            2: 4,
            3: 5,
            4: 3,
            5: 4,
            6: 2,
            7: 4,
            8: 3,
            9: 2

        },
        mood: {
            0: 3,
            1: 4,
            2: 5,
            3: 2,
            4: 1,
            5: 2,
            6: 3,
            7: 2,
            8: 2,
            9: 1

        },
        money: {
            0: 5,
            1: 2,
            2: 3,
            3: 5,
            4: 4,
            5: 2,
            6: 1,
            7: 2,
            8: 5,
            9: 4

        },
        career: {
            0: 4,
            1: 5,
            2: 2,
            3: 3,
            4: 2,
            5: 3,
            6: 5,
            7: 3,
            8: 2,
            9: 5

        }
    },
    Escorpio: {
        love: {
            0: 5,
            1: 4,
            2: 4,
            3: 3,
            4: 5,
            5: 2,
            6: 4,
            7: 3,
            8: 4,
            9: 2
        },
        mood: {
            0: 5,
            1: 2,
            2: 3,
            3: 5,
            4: 2,
            5: 4,
            6: 3,
            7: 5,
            8: 4,
            9: 2
        },
        money: {
            0: 4,
            1: 3,
            2: 2,
            3: 5,
            4: 4,
            5: 3,
            6: 2,
            7: 4,
            8: 2,
            9: 5

        },
        career: {
            0: 5,
            1: 4,
            2: 2,
            3: 4,
            4: 2,
            5: 3,
            6: 4,
            7: 5,
            8: 4,
            9: 3

        }
    },
    Sagitario: {
        love: {
            0: 3,
            1: 2,
            2: 5,
            3: 4,
            4: 3,
            5: 5,
            6: 4,
            7: 3,
            8: 2,
            9: 5

        },
        mood: {
            0: 5,
            1: 2,
            2: 3,
            3: 5,
            4: 2,
            5: 4,
            6: 3,
            7: 5,
            8: 4,
            9: 2

        },
        money: {
            0: 5,
            1: 4,
            2: 3,
            3: 4,
            4: 2,
            5: 5,
            6: 4,
            7: 3,
            8: 5,
            9: 4
        },
        career: {
            0: 5,
            1: 2,
            2: 3,
            3: 5,
            4: 4,
            5: 2,
            6: 1,
            7: 2,
            8: 5,
            9: 4

        }
    },
    Capricornio: {
        love: {
            0: 4,
            1: 3,
            2: 5,
            3: 4,
            4: 2,
            5: 1,
            6: 4,
            7: 5,
            8: 2,
            9: 1

        },
        mood: {
            0: 3,
            1: 4,
            2: 5,
            3: 2,
            4: 4,
            5: 2,
            6: 3,
            7: 5,
            8: 1,
            9: 3

        },
        money: {
            0: 5,
            1: 4,
            2: 3,
            3: 4,
            4: 2,
            5: 5,
            6: 4,
            7: 3,
            8: 5,
            9: 4

        },
        career: {
            0: 4,
            1: 3,
            2: 5,
            3: 4,
            4: 2,
            5: 1,
            6: 4,
            7: 5,
            8: 2,
            9: 1
        }
    },
    Acuario: {
        love: {
            0: 3,
            1: 4,
            2: 5,
            3: 2,
            4: 1,
            5: 2,
            6: 3,
            7: 2,
            8: 2,
            9: 1

        },
        mood: {
            0: 3,
            1: 4,
            2: 5,
            3: 2,
            4: 1,
            5: 2,
            6: 3,
            7: 2,
            8: 2,
            9: 1

        },
        money: {
            0: 4,
            1: 3,
            2: 5,
            3: 4,
            4: 2,
            5: 1,
            6: 5,
            7: 3,
            8: 2,
            9: 1
        },
        career: {
            0: 5,
            1: 4,
            2: 3,
            3: 4,
            4: 2,
            5: 5,
            6: 4,
            7: 3,
            8: 5,
            9: 4

        }
    },
    Piscis: {
        love: {
            0: 3,
            1: 4,
            2: 4,
            3: 5,
            4: 3,
            5: 4,
            6: 2,
            7: 4,
            8: 3,
            9: 2

        },
        mood: {
            0: 5,
            1: 2,
            2: 3,
            3: 5,
            4: 2,
            5: 4,
            6: 3,
            7: 5,
            8: 4,
            9: 2

        },
        money: {
            0: 5,
            1: 4,
            2: 2,
            3: 4,
            4: 2,
            5: 3,
            6: 4,
            7: 5,
            8: 4,
            9: 3

        },
        career: {
            0: 4,
            1: 3,
            2: 2,
            3: 5,
            4: 4,
            5: 3,
            6: 2,
            7: 4,
            8: 2,
            9: 5

        }
    }

}
export const horoscopes_es = {

    Aries: {
        sun_sign: {
            0: `Puede sentir inquietud nerviosa hoy que lo urge a actuar, Aries. Un viaje a un lugar puede hacer que saltes a otro lugar que te lleve en una aventura a un lugar completamente diferente. Puede parecer que estás en una loca búsqueda del tesoro hacia una olla de oro. La energía del día puede hacer que te sientas harapiento, pero no te rindas. La persistencia eventualmente valdrá la pena.`,
        },
        love: {
            0: `Con Júpiter en modo expansión cerca de tu órbita, tienes la necesidad de fundirte. Las parejas Aries pueden unir sus vidas de forma más permanente: mudarse a vivir juntos, prometerse o un embarazo. O, todo se puede acabar así porque sí! Dos eclipses en Leo encienden tu quinta casa y traen una química totalmente inesperada y quizá algo de drama.`,
        },
        career: {
            0: `Las finanzas y el trabajo tendrán un cambio de imagen! Júpiter se acerca para darte nuevos proyectos y ganancias inesperadas, que te pueden generan grandes beneficios. Podrás pagar tus deudas, comprar nuevas viviendas o invertir.  Urano se mueve para Tauro y hace que tus ingresos diarios se incrementen, lo que puede traer nuevos proyectos bastante rentables. Pero siempre mejor paso y buena letra, como Saturno el cauto que se expande en tu órbita profesional para los siguientes tres años, dandóte una percepción de trabajo duro y esfuerzo. Ten tu vista puesta en la recompensa a largo plazo.`,
        },
        money: {
            0: `Las finanzas y el trabajo tendrán un cambio de imagen! Júpiter se acerca para darte nuevos proyectos y ganancias inesperadas, que te pueden generan grandes beneficios. Podrás pagar tus deudas, comprar nuevas viviendas o invertir.  Urano se mueve para Tauro y hace que tus ingresos diarios se incrementen, lo que puede traer nuevos proyectos bastante rentables. Pero siempre mejor paso y buena letra, como Saturno el cauto que se expande en tu órbita profesional para los siguientes tres años, dandóte una percepción de trabajo duro y esfuerzo. Ten tu vista puesta en la recompensa a largo plazo.`,
        },
        health: {
            0: `La salud es un trabajo duro para este año desde que Júpiter la reslató en tu octava casa de la razón, emociones y transformaciones. "Como dentro, así fuera" es tu mantra. Explora la conexión cuerpo-mente. Saturno es disciplinado y te manda vibraciones para que pruebes bootcamp o trabajes con un personal trainer.`,
        },
        planets: {
            0: `Júpiter se vuelve directo en Escorpio, nuevamente diciendo que solo porque no se haya hecho no significa que no se puede lograr. Amplifícate sobre eso, especialmente si prometiste algo ayer. Lo que sea que hagas también tiene poder de permanencia gracias al benevolente Escorpio Júpiter en dirección hacia adelante. Esta noche expande el reino de los sentimientos y la sensibilidad a medida que la luna se vuelve hipersensible a Neptuno. La conexión simultánea con el complejo de Plutón solo complica los problemas. El antídoto es repensar yendo solo con sensaciones instantáneas que podrían estar equivocadas. Tómate tu tiempo porque con Júpiter, la paciencia se recompensa y, por lo tanto, vale la pena.`,
        }
    },
    Tauro: {
        sun_sign: {
            0: `Un buen consejo para que recuerdes es tener cuidado con lo que dices sobre los demás, Tauro. Si está hablando de alguien que no está presente, actúe como si fuera él o ella. ¿Cuál es tu motivación para decir esas cosas? ¿Es necesario hablar de esa manera? Un comentario negativo sobre otra persona va a resonar en el cosmos. La gente podría perder la confianza en ti.`,
        },
        love: {
            0: `Las relaciones serán el centro en 2018 y Júpiter te ayudara a sobrellevar tus peores momentos. Es una etapa de cambio muy necesaria, ya que entre 2012-2018 las relaciones no han sido lo tuyo. De las batallas y las lecciones se sacan cicatrices que hacen más sabio y puedes aplicar desde tu experiencia para tener relaciones mas felicies y saludables para 2018 como minimo!`,
        },
        career: {
            0: `Júpiter te recomienda tener buenos socios en los negocios pero guarda siempre algo para tus proyectos en solitario. Urano entra en la órbita de Tauro por primera vez en 77 años a mediados de Mayo, bendiciendote con su influencia hasta 2026. Un proyecto alternativo puede hacerte famoso. Con Saturno en tu órbita, puede que tu crecimiento se estanque pero incrementara paulatinamente para tu propio beneficio. Dos eclipses en tu órbita pueden traerte oportunidades laborales y ofertas inesperadas-incluso un nuevo camino laboral.`,
        },
        money: {
            0: `Júpiter te recomienda tener buenos socios en los negocios pero guarda siempre algo para tus proyectos en solitario. Urano entra en la órbita de Tauro por primera vez en 77 años a mediados de Mayo, bendiciendote con su influencia hasta 2026. Un proyecto alternativo puede hacerte famoso. Con Saturno en tu órbita, puede que tu crecimiento se estanque pero incrementara paulatinamente para tu propio beneficio. Dos eclipses en tu órbita pueden traerte oportunidades laborales y ofertas inesperadas-incluso un nuevo camino laboral.`,
        },
        health: {
            0: `Júpiter se aventura en tu órbita desde 2018 para ayudarte a desarrollar mejores habitos y mejorar tu salud. Este año, te ayudaran tus amigos. Asi combinaras ejercicio y dieta saludable con tus actividades sociales. Queda con tus amigos para un paseo en bici en lugar de en el bar, o combina una llamada online con un paseo energetico en lugar de quedarte en sentado en tu escritorio. Urano aparecera en tu órbita para inspirarte especialmente en verano u otoño.`,
        },
        planets: {
            0: `Un eclipse solar simboliza un tiempo significativo de desarrollo. Con el eclipse de Cáncer, el aspecto del Sol y de la Luna transforma a Plutón retrógrado, enviando un mensaje aún más valioso y, tal vez para muchos, una nueva perspectiva. Las cosas se ven diferentes cuando uno les da nuevos significados. Hoy y esta tarde, también preste especial atención a las coincidencias. Las pistas están en todas partes, y son cosas que comprenderás en un instante.
            Esta noche, se sentirá confundido cuando se comuniquen los aspectos de Mercurio nebulosos Neptuno. Este último es el rey de los mensajes ocultos sutiles, multiplicando la importancia y la cantidad de mensajes que recibe hoy.`,
        }
    },
    Géminis: {
        sun_sign: {
            0: `Es posible que necesite un poco de tiempo a solas hoy para volver al centro, Géminis. La independencia es una palabra clave, así que mantenla en el fondo de tu mente. Asegúrese de no ser víctima de un compromiso que hizo hace mucho tiempo. A medida que el paisaje cambia, también debemos cambiar. Las acciones obstinadas serán extremadamente perjudiciales en un día como este. Se honesto y agradecido por las cosas que tienes.`,
        },
        love: {
            0: `Buenas noticias: Saturno ha terminado su emigracion de 3 años por tu signo contrario, Sagitario, una etapa bastante complicada que ha puesto a tus relaciones a prueba. Y en Noviembre, Júpiter llega por fin, atrayendo un crecimiento bastante excitante y con propositos a largo plazo. Pero eso no es todo: Saturno esta ahora en órbita mas intima, enseñandote una leccion dura pero crucial sobre como establacer relaciones que duren. Preparate para enfrentar cualquier miedo y problemas de confianza, y hacer sitio para relaciones mas sanas con esfuerzo y humildad.`,
        },
        career: {
            0: `Nuevas oportunidades para este año, ya que Júpiter visita tu órbita. Estas aprendiendo a delegar, organizar y llevar tu vida sobre ruedas. ¿Aburrido o sin mucho que hacer? Pillate un trabajo temporal para pagar tus gastos mientras piensas en lo que te depara el futuro. El eclipse de Julio puede traerte excitantes oportunidades - una buena razon para no meterte prisa por encontrar algo permanente! Con Saturno en tu zona de riqueza, es momento para aprender mas sobre invertir, inmuebles y rentas. Puedes pagar todas tus deudas y empezar tu propia independencia.`,
        },
        money: {
            0: `Nuevas oportunidades para este año, ya que Júpiter visita tu órbita. Estas aprendiendo a delegar, organizar y llevar tu vida sobre ruedas. ¿Aburrido o sin mucho que hacer? Pillate un trabajo temporal para pagar tus gastos mientras piensas en lo que te depara el futuro. El eclipse de Julio puede traerte excitantes oportunidades - una buena razon para no meterte prisa por encontrar algo permanente! Con Saturno en tu zona de riqueza, es momento para aprender mas sobre invertir, inmuebles y rentas. Puedes pagar todas tus deudas y empezar tu propia independencia.`,
        },
        health: {
            0: `Júpiter esta tu órbita de salud y fitness, empujandote a tomarte tu bienestar como una aventura. Comer sano y ejercicio fisico son los mejores ingredientes para la felicidad - y lo mejor si puedes hacerlo al aire libre! El aire fresco y la naturaleza te renovaran y ,con Urano empezando su órbita holistica y mistica en Mayo, tendras una oportunidad unica para disfrutar de un tiempo inmejorable cerca del agua que calmara tu alma.`,
        },
        planets: {
            0: `Un eclipse solar simboliza un tiempo significativo de desarrollo. Con el eclipse de Cáncer, el aspecto del Sol y de la Luna transforma a Plutón retrógrado, enviando un mensaje aún más valioso y, tal vez para muchos, una nueva perspectiva. Las cosas se ven diferentes cuando uno les da nuevos significados. Hoy y esta tarde, también preste especial atención a las coincidencias. Las pistas están en todas partes, y son cosas que comprenderás en un instante.
            Esta noche, se sentirá confundido cuando se comuniquen los aspectos de Mercurio nebulosos Neptuno. Este último es el rey de los mensajes ocultos sutiles, multiplicando la importancia y la cantidad de mensajes que recibe hoy.`,
        }
    },
    Cáncer: {
        sun_sign: {
            0: `No piense automáticamente que la belleza siempre tiene que definirse por estándares pasados ​​de moda, Cáncer. Es hora de crear su propia definición. No hay necesidad de encajar en un molde socialmente construido que no resuene con lo que realmente eres. Tu trabajo no es intentar y asegurarte de que todos te amen. Solo hay una persona que necesitas satisfacer, y ese eres tú.`,
        },
        love: {
            0: `¡La llamada de Cupido! Prepárate para un año de de total crecimiento en el juego del amor. Júpiter se va a pasar la mayor parte del año en tu órbita de la pasión, trayendo atracciones muy fuertes y bendiciéndote con ese "no sé qué" irresistible. Pero no durará mucho ya que Saturno se establecerá en tu órbita del compromiso hasta 2020. Probarás largas relaciones de pareja, posiblemente fuera de esa atracción o sin la necesidad de focalizarse en el romance otra vez.`,
        },
        career: {
            0: `Urano finalmente aterriza en tu órbita profesional en Mayo (haciendo una rápida parada por tu bien antes de que se vaya). Tu camino profesional por fin verá algún progreso y podrás empezar a asentarte. Pero puede que te diviertas siendo independiente, ya que Urano entra en tu zona tecnológica, dándote la oportunidad laboral de un trabajo más virtual y de trabajar donde quieras. Cuatro eclipses en tu órbita monetaria te traerán oportunidades para ganar, invertir y unir ambos beneficios. El eclipse de Julio en Cáncer puede traerte proyectos en solitario, mientras que Saturno en tu zona más social te pondrá un colaborador en el camino.`,
        },
        money: {
            0: `Urano finalmente aterriza en tu órbita profesional en Mayo (haciendo una rápida parada por tu bien antes de que se vaya). Tu camino profesional por fin verá algún progreso y podrás empezar a asentarte. Pero puede que te diviertas siendo independiente, ya que Urano entra en tu zona tecnológica, dándote la oportunidad laboral de un trabajo más virtual y de trabajar donde quieras. Cuatro eclipses en tu órbita monetaria te traerán oportunidades para ganar, invertir y unir ambos beneficios. El eclipse de Julio en Cáncer puede traerte proyectos en solitario, mientras que Saturno en tu zona más social te pondrá un colaborador en el camino.`,
        },
        health: {
            0: `¡Libre por fin! Saturno acaba de pasarse los tres últimos años en tu órbita del bienestar, poniéndote difícil encontrar tiempo para tu puesta a punto. Un problema de salud puede haberte forzado a re-estructurar tu estilo de vida o cambiar tus hábitos alimentarios y de ejercicio. Con Saturno ya desaparecido, el equilibrio y la estabilidad han vuelto. El eclipse solar del 12 de Julio en Cáncer te traerá mucha energía e incluso un nuevo look.`,
        },
        planets: {
            0: `Un eclipse solar simboliza un tiempo significativo de desarrollo. Con el eclipse de Cáncer, el aspecto del Sol y de la Luna transforma a Plutón retrógrado, enviando un mensaje aún más valioso y, tal vez para muchos, una nueva perspectiva. Las cosas se ven diferentes cuando uno les da nuevos significados. Hoy y esta tarde, también preste especial atención a las coincidencias. Las pistas están en todas partes, y son cosas que comprenderás en un instante.
            Esta noche, se sentirá confundido cuando se comuniquen los aspectos de Mercurio nebulosos Neptuno. Este último es el rey de los mensajes ocultos sutiles, multiplicando la importancia y la cantidad de mensajes que recibe hoy.`,
        }

    },
    Leo: {

        sun_sign: {
            0: `Los problemas pueden ser un poco más pesados ​​de lo que hoy te gustaría, Leo. Tu trabajo es infundir algo de diversión en la situación. Sus poderes de adaptabilidad serán puestos a prueba, ya que otras personas parecen estar completamente obsesionadas con sus opiniones. Sé más consciente de cómo tus palabras. Otras personas, especialmente los superiores o los ancianos, son propensos a ofenderse por comentarios descuidados y espontáneos.`,
        },
        love: {
            0: `¡Cambios! Tus relaciones están cambiando, junto con tus prioridades, ya que entramos en el segundo año de eclipses sísmicos en Leo y Acuario. Desde 2018 hasta 2019, entrarás en transformaciones muy personales que alterarán totalmente tu deseo de una relación de pareja. Los eclipses te traerán sorpresas y momentos de cambio. Podrás tener un pequeño break en un romance que seguirá su curso al final o podrás correrás al altar. Incluso las parejas más estables y unidas crecerán personalmente en este etapa. Para finalizar, en Noviembre, Júpiter empieza su mes número 13 visitando tu órbita de la pasión. Una cosa es verdad: el amor no será más que un negocio para ti, como en 2018.`,
        },
        career: {
            0: `¡Unas fronteras ambiciosas te están esperando! A mediados de Mayo, Urano empieza su visita a Tauro en la órbita profesional-por primera vez en 77 años. Desda ahora y hasta 2026, podrás explorar diferentes caminos profesionales. Tu trabajo podrá incluir tecnologías o una causa benéfica. Los dos eclipses de Leo de este año te marcarán bastante. Todo tu glamour saldrá a la luz! Así que asegúrate de tener la ayuda de un experto para conseguir lo que te mereces en la alfombra roja. No te puedes andar con tapujos, pida la ayuda de un profesional en lugar de hacer todo DIY.`,
        },
        money: {
            0: `¡Unas fronteras ambiciosas te están esperando! A mediados de Mayo, Urano empieza su visita a Tauro en la órbita profesional-por primera vez en 77 años. Desda ahora y hasta 2026, podrás explorar diferentes caminos profesionales. Tu trabajo podrá incluir tecnologías o una causa benéfica. Los dos eclipses de Leo de este año te marcarán bastante. Todo tu glamour saldrá a la luz! Así que asegúrate de tener la ayuda de un experto para conseguir lo que te mereces en la alfombra roja. No te puedes andar con tapujos, pida la ayuda de un profesional en lugar de hacer todo DIY.`,
        },
        health: {
            0: `¿Sufre y aprenderás? Este año tu bienestar se mejorará bastante, ayudándote a sentir tu mente, cuerpo y corazón. Júpiter está en tu órbita emocional, lo que te ayudará a tener más tiempo para ti mismo. Mientras tanto, Saturno afectará tu órbita de la salud hasta 2020, forzándote a reducir tu estrés. El ejercicio físico y una alimentación saludable serán tus obligaciones. Tendrás que decir "no" (la palabra favorita de los Leo) a unas cuantas cosas para convertirte en el Number One. Puede ser más difícil de como suena, así que olvídate de las tonterías en nombre de tu salud y felicidad. El eclipse de Julio en Cáncer podrá ser el mejor momento para una cura espiritual o para un retiro cerca del agua.`,
        },
        planets: {
            0: `Un eclipse solar simboliza un tiempo significativo de desarrollo. Con el eclipse de Cáncer, el aspecto del Sol y de la Luna transforma a Plutón retrógrado, enviando un mensaje aún más valioso y, tal vez para muchos, una nueva perspectiva. Las cosas se ven diferentes cuando uno les da nuevos significados. Hoy y esta tarde, también preste especial atención a las coincidencias. Las pistas están en todas partes, y son cosas que comprenderás en un instante.
            Esta noche, se sentirá confundido cuando se comuniquen los aspectos de Mercurio nebulosos Neptuno. Este último es el rey de los mensajes ocultos sutiles, multiplicando la importancia y la cantidad de mensajes que recibe hoy.`,
        }
    },
    Virgo: {
        sun_sign: {
            0: `Si el pomo de la puerta no quiere girar hoy, Virgo, no lo fuerce. Solo lograrás romper la llave. Quizás solo necesites probar con otra puerta. Si las cosas no fluyen suavemente en su lugar, entonces probablemente no estaban destinadas a serlo. La vida no debería ser una lucha. Nuestro trabajo es ser feliz. Recuerda eso la próxima vez que estés en una larga fila. Ver la situación como un período de descanso.`,
        },
        love: {
            0: `Tu vida amorosa no será lo más importante este año, pero eso no significa que no te lo puedas pasar bien! Con Júpiter en tu órbita social, los Virgo solteros se lo pasarán muy bien coqueteando y tendrán encuentros muy divertidos. Pero eso sí, comprueba bien todas las opciones antes de elegir. Los Virgo emparejados podrán mantener la chispa explorando hobbies nuevos o conociendo nuevos retos. ¿Otra razón para no apresurarse? Saturno pasará los próximos tres años en tu órbita amorosa, haciendo que te vuelvas más díficil -y exquisito- de lo que ya eres.`,
        },
        career: {
            0: `¡Expande tu mensaje a las masas! Con Júpiter en tu órbita comunicativa hasta Noviember, enseñar e influir son tus puntos fuertes en 2018. Basta ya de esconderse-tienes ideas que pueden cambiar la vida de la gente. ¿Será el momento de rehacer el imperio de Virgo con tus mejores galas? Urano se mueve cerca de tu órbita en Mayo para traerte los mejores trucos de influencer y las mejores conexiones. Desde memes hasta Medium, internet es tu canvas. Pero evita lo trivial si quieres hacerte viral. Con Saturno tan zona creativa hasta 2020, solo el contenido más pulido podrá construir tu lealtad.`,
        },
        money: {
            0: `¡Expande tu mensaje a las masas! Con Júpiter en tu órbita comunicativa hasta Noviember, enseñar e influir son tus puntos fuertes en 2018. Basta ya de esconderse-tienes ideas que pueden cambiar la vida de la gente. ¿Será el momento de rehacer el imperio de Virgo con tus mejores galas? Urano se mueve cerca de tu órbita en Mayo para traerte los mejores trucos de influencer y las mejores conexiones. Desde memes hasta Medium, internet es tu canvas. Pero evita lo trivial si quieres hacerte viral. Con Saturno tan zona creativa hasta 2020, solo el contenido más pulido podrá construir tu lealtad.`,
        },
        health: {
            0: `Según Buddha: Nuestros pensamientos nos dan forma, nos convertimos en lo que pensamos. Con Júpiter tan cerca hasta Noviembre, es hora de que nutrir tus pensamientos de las mejores fuentes. Escucha una playlist con música que de positividad, o escucha podcast or charlas TED. Ponte metáfisico y deja que tus pensamientos fluyan. Y presta atención a lo que todo esto genera en ti, en qué palabras se traduce. Las palabras, más que nunca, tiene el poder de transformar tu realidad.`,
        },
        planets: {
            0: `Un eclipse solar simboliza un tiempo significativo de desarrollo. Con el eclipse de Cáncer, el aspecto del Sol y de la Luna transforma a Plutón retrógrado, enviando un mensaje aún más valioso y, tal vez para muchos, una nueva perspectiva. Las cosas se ven diferentes cuando uno les da nuevos significados. Hoy y esta tarde, también preste especial atención a las coincidencias. Las pistas están en todas partes, y son cosas que comprenderás en un instante.
            Esta noche, se sentirá confundido cuando se comuniquen los aspectos de Mercurio nebulosos Neptuno. Este último es el rey de los mensajes ocultos sutiles, multiplicando la importancia y la cantidad de mensajes que recibe hoy.`,
        }
    },
    Libra: {
        sun_sign: {
            0: `Su nuevo enfoque de las cosas puede ser algo molesto por los demás hoy en día, Libra, pero no dejes que eso te detenga. Tenga en cuenta que su naturaleza independiente y algo rebelde es un ingrediente clave para mantener el mundo en equilibrio. No renuncies a la lucha cuando las viejas y cansadas formas de hacer las cosas insistan en tomar la delantera. Usa tu poder desde dentro para combatir las fuerzas desde arriba.`,
        },
        love: {
            0: `La confianza en uno mismo es irresistible-y este año vas a empezar a tener a bastante, ya que Júpiter visita tu órbita. Estás atraido por la estabilidad y podrías conocer a una pareja estable. Alguien al que considerabas aburrido ahora te parece un buen partido, (y probablemente lo sea!). Las parejas pueden asentarse más en la relación durante este tiempo. Urano termina en Mayo su visita por tu órbita sentimental, añadiendo más consistencia a tus compromisos. Pero no todo está escrito. Los dos eclipses llenos de pasión y energía de Febrero y Julio podrán traerte nuevos romances e incluso noticias de embarazo.`,

        },
        career: {
            0: `Aquí vienen las recompensas! Júpiter se quedaráen tu órbita del trabajo y el dinero la mayor parte del año. Esto hará que un nuevo trabajo, un ascenso o un nuevo destino laboral aparezca en tu vida. 2018 puede ser el mejor año en tus finanzas de toda la década. Urano empieza a visitar tu órbita en Mayo, lo que te puede ser de mucha ayuda. Puede que empieces a pensar en invertir en inmuebles o en negocios online. El eclipse solar de Julio parece que escribe "CEO" en tu órbita! Puede dispararte a un puesto de liderazgo o ganar un puesto de gran prestigio.`,
        },
        money: {
            0: `Aquí vienen las recompensas! Júpiter se quedaráen tu órbita del trabajo y el dinero la mayor parte del año. Esto hará que un nuevo trabajo, un ascenso o un nuevo destino laboral aparezca en tu vida. 2018 puede ser el mejor año en tus finanzas de toda la década. Urano empieza a visitar tu órbita en Mayo, lo que te puede ser de mucha ayuda. Puede que empieces a pensar en invertir en inmuebles o en negocios online. El eclipse solar de Julio parece que escribe "CEO" en tu órbita! Puede dispararte a un puesto de liderazgo o ganar un puesto de gran prestigio.`,
        },
        health: {
            0: `Los hábitos saludables lo son todo este año. Júpiter influye en todas tus rutinas con un ritmo bastante inspirador y saludable. Puede sonar obvio, pero comer,  irse a la cama y levantarse a las mismas horas puede incrementar tu vitalidad. No te compliques ni en tu dieta, ni en el ejercicio ni en tu vida. Para las mujeres Libra, puede que padezcas una especial sensibilidad hormonal debido a la influencia de Saturno.`,
        },
        planets: {
            0: `Un eclipse solar simboliza un tiempo significativo de desarrollo. Con el eclipse de Cáncer, el aspecto del Sol y de la Luna transforma a Plutón retrógrado, enviando un mensaje aún más valioso y, tal vez para muchos, una nueva perspectiva. Las cosas se ven diferentes cuando uno les da nuevos significados. Hoy y esta tarde, también preste especial atención a las coincidencias. Las pistas están en todas partes, y son cosas que comprenderás en un instante.
            Esta noche, se sentirá confundido cuando se comuniquen los aspectos de Mercurio nebulosos Neptuno. Este último es el rey de los mensajes ocultos sutiles, multiplicando la importancia y la cantidad de mensajes que recibe hoy.`,
        }
    },
    Escorpio: {
        sun_sign: {
            0: `Es posible que se te pida que elijas entre dos formas de manejar una situación, Escorpio. Las viejas formas de hacer las cosas están en conflicto con lo nuevo. ¿De qué manera vas a proceder? No te desvíes de la charla rápida y la prestidigitación. Además, no asuma que la forma en que funcionó para siempre sigue siendo la mejor solución. Usa tu intuición para elegir la mejor ruta para ti.`,
        },
        love: {
            0: `¡Por fin! Júpiter está en tu signo para hacer que te enamores de tu vida otra vez. Urano empieza la visita a tu signo trayéndote a gente facinante (y extravagante) a tu órbita. Las parejas Escorpio pueden sufrir grandes cambios. ¿Eres un Escorpio soltero? Puedes impresionarte a ti mismo (y a tus amigos) eligiendo a alguien completamente diferente a tu tipo. Bajo esta impulsividad, puedes tener (y terminar) relaciones muy rápidas y frenéticas.`,
        },
        career: {
            0: `¡El agobio se ha acabado! En Diciembre de 2018, Saturno terminará su tránsito por tu órbita financiera, que ha estado obligándote a abrocharte el cinturón. Utiliza tus mejores habilidades y sabiduría para crear tu nido ahora. Dos eclipses en Leo encienden las oportunidades en tu carrera profesional cuando menos te lo esperas. La abundancia comenzará en Noviembre, cuando Júpiter empiece su 13 mes de visita por tu órbita`,
        },
        money: {
            0: `¡El agobio se ha acabado! En Diciembre de 2018, Saturno terminará su tránsito por tu órbita financiera, que ha estado obligándote a abrocharte el cinturón. Utiliza tus mejores habilidades y sabiduría para crear tu nido ahora. Dos eclipses en Leo encienden las oportunidades en tu carrera profesional cuando menos te lo esperas. La abundancia comenzará en Noviembre, cuando Júpiter empiece su 13 mes de visita por tu órbita`,
        },
        health: {
            0: `Urano deja tu órbita de la salud y el bienestar después de siete años y por fin puedes reanudar tus expectativas en este campo. Puede que hayas renovado totalmente tu dieta y ejercicio durante este tiempo. Urano visitará por última vez a Aries de Noviembre de 2018 a Marzo de 2019, así sigue usando tu Fibit and Vitamix. Con Saturno en tu órbita, puede que hagas un maratón o alguna carrera por una causa.`,
        },
        planets: {
            0: `Un eclipse solar simboliza un tiempo significativo de desarrollo. Con el eclipse de Cáncer, el aspecto del Sol y de la Luna transforma a Plutón retrógrado, enviando un mensaje aún más valioso y, tal vez para muchos, una nueva perspectiva. Las cosas se ven diferentes cuando uno les da nuevos significados. Hoy y esta tarde, también preste especial atención a las coincidencias. Las pistas están en todas partes, y son cosas que comprenderás en un instante.
            Esta noche, se sentirá confundido cuando se comuniquen los aspectos de Mercurio nebulosos Neptuno. Este último es el rey de los mensajes ocultos sutiles, multiplicando la importancia y la cantidad de mensajes que recibe hoy.`,
        }
    },
    Sagitario: {
        sun_sign: {
            0: `Los eventos inesperados pueden estar barajando las cartas cuando menos lo esperas, Sagitario. Si has vigilado de cerca el mazo, contando los jacks a medida que aparecen, es posible que te tomen una vuelta. No te desanimes Todos los demás están sujetos a las mismas reglas que usted. Si el distribuidor parece torcido, vaya a otra mesa. No caiga en el mismo truco dos veces.`,
        },
        love: {
            0: `¿No más drama? Urano, el planeta de los cambios imprevistos, se retirará de tu órbita del amor y la pasión a mediados en Mayo, después de siete años. Pero con Júpiter en tu órbita de la fantasía hasta Noviembre, podrías despegar este año. ¿Esta persona tu alma gemela... o está solo depaso? Es complicado de saber. A mediados de Julio, un eclipse podría hacer que los Arqueros por fin digan "Sí, quiero". Otros Sagitario pueden sufrir una ruptura o una transición en su vida que les conlleve mucha energía. Date ese tiempo. Emergerás de tu capullo para alzar tus alas cuando Júpiter entre en Sagitario en Noviembre, cumpliendo su mes número 13.`,
        },
        career: {
            0: `Has crecido tanto, Sagitario, gracias a la madurez que te ha dado Saturno en su tercer en tu órbita, desde 2014 a 2018. Ahora, Saturno te trae tranquilidad a tus finanzas, haciéndote pensar en tus presupuestos y dando prioridad a un seguridad financiera más duradera. Es hora de empezar tu hogar. Quizá tengas que vivir más ajustado, pero verás los frutos con el tiempo. Una asociación inesperada o una ganancia inesperada llegará en el eclipse solar del 12 de Julio en Cáncer. En 2018, hay dos lunes llenas en Cáncer, el 1 de Enero y el 22 de Diciembre, que pueden sentenciar tu año con abundantes bonos.`,
        },
        money: {
            0: `Has crecido tanto, Sagitario, gracias a la madurez que te ha dado Saturno en su tercer en tu órbita, desde 2014 a 2018. Ahora, Saturno te trae tranquilidad a tus finanzas, haciéndote pensar en tus presupuestos y dando prioridad a un seguridad financiera más duradera. Es hora de empezar tu hogar. Quizá tengas que vivir más ajustado, pero verás los frutos con el tiempo. Una asociación inesperada o una ganancia inesperada llegará en el eclipse solar del 12 de Julio en Cáncer. En 2018, hay dos lunes llenas en Cáncer, el 1 de Enero y el 22 de Diciembre, que pueden sentenciar tu año con abundantes bonos.`,
        },
        health: {
            0: `Con Júpiter en tu órbita hasta Noviembre, puedes estar tan cansado como siempre. Date un respiro y focaliza tu energía en objetivos más espirituales, curativos y de descubrimiento personal. Si te fuerzas a seguir una agenda, solo te traeráfrustación, pero si, en cambio, te rindes y te dejas guiar por el universo, entonces los milagros podrán ocurrir. Afortunadamente, Urano se instalará en tu órbita de la salud y el bienestar a mediados de Mayo. Prepárate para mejorar tu dieta y tu estilo de vida - algo que probablemente agradecerás.`,
        },
        planets: {
            0: `Un eclipse solar simboliza un tiempo significativo de desarrollo. Con el eclipse de Cáncer, el aspecto del Sol y de la Luna transforma a Plutón retrógrado, enviando un mensaje aún más valioso y, tal vez para muchos, una nueva perspectiva. Las cosas se ven diferentes cuando uno les da nuevos significados. Hoy y esta tarde, también preste especial atención a las coincidencias. Las pistas están en todas partes, y son cosas que comprenderás en un instante.
            Esta noche, se sentirá confundido cuando se comuniquen los aspectos de Mercurio nebulosos Neptuno. Este último es el rey de los mensajes ocultos sutiles, multiplicando la importancia y la cantidad de mensajes que recibe hoy.`,
        }
    },
    Capricornio: {
        sun_sign: {
            0: `Tu sentido del yo puede estar un poco desafiado hoy, Capricornio. Es posible que simplemente tenga problemas para levantarse de la cama. Recuerda que la forma en que los demás te ven no necesariamente significa que realmente eres así. No sientas que tienes que cambiar para complacer a nadie. En definitiva, su única responsabilidad es para usted. Pueden ocurrir eventos extraños que te motiven a cambiar tu forma de pensar.`,
        },
        love: {
            0: `¿Romance con un toque distinto? Urano entrará en tu órbita este mes de Mayo, trayéndote deseos que te sorprenderán hasta a ti. Un embarazo es posible. ¿En pareja? La monogamia no debería de significar monotonía, y Urano os podrá ayudar a traer nuevos deseos fogosos a las parjeas de larga duración. En Julio, un eclipse solar en tu órbita del compromiso hará que avances de forma muy rápida a un estado más oficial. Las parejas de larga duración vivirán un nuevo capítulo en su vida, que les traerá una etapa de cambio y paz.`,
        },
        career: {
            0: `Con Saturno (tu gobernante) en tu signo durante los siguientes tres años, ¡te tomarás tus objetivos en serio! Poco a poco, podrás formar tu pequeño imperio. Si eres un experto en tu campo, Saturno te podrá ayudar a establecerte como una persona reconocida y respetada. El modo en gestión tu dinero cambiará este año, debido a los cuatro eclipses que ocurrirán en tu órbita financiera. Podrás experimentar un negocio aventurero, una inversión o la adquisición de un inmueble. Con Júpiter en tu órbita del trabajo en equipo y la tecnología, las colaboraciones dentro de tu círculo social abundarán este año.`,
        },
        money: {
            0: `Con Saturno (tu gobernante) en tu signo durante los siguientes tres años, ¡te tomarás tus objetivos en serio! Poco a poco, podrás formar tu pequeño imperio. Si eres un experto en tu campo, Saturno te podrá ayudar a establecerte como una persona reconocida y respetada. El modo en gestión tu dinero cambiará este año, debido a los cuatro eclipses que ocurrirán en tu órbita financiera. Podrás experimentar un negocio aventurero, una inversión o la adquisición de un inmueble. Con Júpiter en tu órbita del trabajo en equipo y la tecnología, las colaboraciones dentro de tu círculo social abundarán este año.`,
        },
        health: {
            0: `La simplicidad. Mientras que Saturno está en Capricornio, necesitarás reducir los excesos y priorizar tus necesidades. Afortunadamente, muchos Capricornio ya siguen este enfoque de "menos es más". Saturno regulará tu tiempo, y mientras está en tu órbita de las apariencias, puede que empieces a seguir tratamientos anti-edad o formas más naturales de mantener tu vitalidad. O, aceptarás la belleza de hacerse mayor. En Noviembre, Júpiter entra en tu órbita curativa en su 13 mes, un perido espiritual de descanso y relax.`,
        },
        planets: {
            0: `Un eclipse solar simboliza un tiempo significativo de desarrollo. Con el eclipse de Cáncer, el aspecto del Sol y de la Luna transforma a Plutón retrógrado, enviando un mensaje aún más valioso y, tal vez para muchos, una nueva perspectiva. Las cosas se ven diferentes cuando uno les da nuevos significados. Hoy y esta tarde, también preste especial atención a las coincidencias. Las pistas están en todas partes, y son cosas que comprenderás en un instante.
            Esta noche, se sentirá confundido cuando se comuniquen los aspectos de Mercurio nebulosos Neptuno. Este último es el rey de los mensajes ocultos sutiles, multiplicando la importancia y la cantidad de mensajes que recibe hoy.`,
        }
    },
    Acuario: {
        sun_sign: {
            0: `A medida que sigas el camino hacia la adquisición de lo último, lo mejor, lo más rápido y lo mejor, es posible que descubras que estás dejando atrás algunos principios y valores fundamentales en el camino, Acuario. No pierdas de vista tu base. Las cosas podrían sacudirse hoy. Tu ego podría estar en juicio por su comportamiento de cabeza de cerdo. Manténgase controlado y tenga en cuenta la forma en que se proyecta a los demás.`,
        },
        love: {
            0: `Tus relaciones están teniendo una gran evolucion este año, ya que los cuatro eclipses tocarán la conexión Leo/Acuario. Harás una revisión a tus necesidades personales y tu forma de ver las relaciones este año. Esto te puede traer desde una ruptutra inesperada, a un compromiso repentino o a mejorar la dinámica en tu amor a largo plazo. El equilibrio entre el "yo" y el "nosotros" será el objetivo de estos tres eclipses-y como siempre el santo grial para tu signo, independiente pero amante de la gente.`,
        },
        career: {
            0: `¡Enhorabuena por tu éxito, Acuario! Júpiter se quedará en tu órbita hasta Noviembre, atrayendo nuevas posibilidades llenas de ambición y profesionalidad. Este año puede ser uno de los más afortunados de la última década para por fin asumir un riesgo en tu carrera profesional. Puede que te asciendan o empieces un nuevo trabajo en otro lugar o en el que tengas que viajar.`,
        },
        money: {
            0: `¡Enhorabuena por tu éxito, Acuario! Júpiter se quedará en tu órbita hasta Noviembre, atrayendo nuevas posibilidades llenas de ambición y profesionalidad. Este año puede ser uno de los más afortunados de la última década para por fin asumir un riesgo en tu carrera profesional. Puede que te asciendan o empieces un nuevo trabajo en otro lugar o en el que tengas que viajar.`,
        },
        health: {
            0: `¿Necesitas un descanso? Saturno se expanderá durante los próximos tres años en tu órbita del descanso y el bienestar. Tendrás que aprender a decir no y a no tener por qué agradar a todo el mundo. Tienes que dar más importancia a tu bienestar personal, creando una rutina simple y del mantenimiento de tu tranquilidad interior. Puedes empezar por ir a dormir a la misma hora y comer en la misma hora. Si trabajas en el campo del bienestar, Saturno puede bendecirte con un nuevo don. A mediados de Julio, un eclipse solar cerca de tu órbita puede darte el último empujón para cambiar tu estilo de vida.`,
        },
        planets: {
            0: `Un eclipse solar simboliza un tiempo significativo de desarrollo. Con el eclipse de Cáncer, el aspecto del Sol y de la Luna transforma a Plutón retrógrado, enviando un mensaje aún más valioso y, tal vez para muchos, una nueva perspectiva. Las cosas se ven diferentes cuando uno les da nuevos significados. Hoy y esta tarde, también preste especial atención a las coincidencias. Las pistas están en todas partes, y son cosas que comprenderás en un instante.
            Esta noche, se sentirá confundido cuando se comuniquen los aspectos de Mercurio nebulosos Neptuno. Este último es el rey de los mensajes ocultos sutiles, multiplicando la importancia y la cantidad de mensajes que recibe hoy.`,
        }
    },
    Piscis: {
        sun_sign: {
            0: `Clave en tu naturaleza sensual y hermosa, Piscis. Tómese un tiempo cada día para atender su alma y asegurarse de que está obteniendo la nutrición que necesita irradiar al mundo. Gente inesperada podría aparecer de la nada, así que no te sorprendas si un ex amante llega a llamar. Las cosas del pasado pueden estar volviendo al presente para enseñarle una valiosa lección de vida.`,
        },
        love: {
            0: `¡La libertad es un afrodisiaco! Los dos últimos años has tenido una relación complicada ya que Júpiter estaba en tu órbita. Puede que tengas algo serio con una persona especial o dividas los caminos en una relación larga. Quizá te has pasado una gran cantidad de tiempo apoyando a tu pareja o desconectando en vuestra burbuja. Ahora, ya estás listo para asomar la cabeza y ver el mundo ahí fuera, ya que Júpiter está en tu órbita para traerte libertad. La gente que te ha dado el espacio para expandirte son a los que mantendrás cerca. Viajar, aprender e incluso empezar un negocio juntos puede hacer que tu corazón lata más deprisa. Para los Piscis solter@s, puede que salte la chispa con alguien de otra cultura o país. El eclipse del 12 de Julio en tu órbita romántica te traerá amor o incluso un embarazado de la nada.`,
        },
        career: {
            0: `¡Ya te has quitado un peso de encima! En Diciembre de 2017, Saturno finalmente terminó su estancia de tres años en tu órbita profesional, esto te obligaba a ser más estructurado. Si tenías altibajos, el ritmo ahora seguramente se acelere. Puedes hacer un cambio de 180 grados del pesimismo al optimismo, así como a nuevas posibilidades para este año. Júpiter se encargará de que mantegas esta situación hasta Noviembre. Y en Noviembre, Júpiter empezará su mes número 13 en tu sector profesional, lo que hará que este año sea el más afortunado en tu carrera profesional en la última década. En Mayo, Urano terminará su séptimo año en tu sector financiero, haciendo más fácil que te estabilizar tu trabajo y tu dinero.`,
        },
        money: {
            0: `¡Ya te has quitado un peso de encima! En Diciembre de 2017, Saturno finalmente terminó su estancia de tres años en tu órbita profesional, esto te obligaba a ser más estructurado. Si tenías altibajos, el ritmo ahora seguramente se acelere. Puedes hacer un cambio de 180 grados del pesimismo al optimismo, así como a nuevas posibilidades para este año. Júpiter se encargará de que mantegas esta situación hasta Noviembre. Y en Noviembre, Júpiter empezará su mes número 13 en tu sector profesional, lo que hará que este año sea el más afortunado en tu carrera profesional en la última década. En Mayo, Urano terminará su séptimo año en tu sector financiero, haciendo más fácil que te estabilizar tu trabajo y tu dinero.`,
        },
        health: {
            0: `¡Aire fresco, por favor! Con Júpiter en tu órbita, los espacios abiertos te harán muy feliz. Combinar actividad física y tiempo en la naturaleza hará que tu espíritu se dispare durante este año. Cuatro de los cinco eclipses de este año tocarán tu salud, lo que te puede ayudar a cambiar tu dieta, añadir rutinas de ejercicio a tu día a día o cambiar tu estilo de vida. Algunos Piscis se interesarán por la espiritualidad de las cosas o adoptarán una práctica curativa.`,
        },
        planets: {
            0: `Un eclipse solar simboliza un tiempo significativo de desarrollo. Con el eclipse de Cáncer, el aspecto del Sol y de la Luna transforma a Plutón retrógrado, enviando un mensaje aún más valioso y, tal vez para muchos, una nueva perspectiva. Las cosas se ven diferentes cuando uno les da nuevos significados. Hoy y esta tarde, también preste especial atención a las coincidencias. Las pistas están en todas partes, y son cosas que comprenderás en un instante.
            Esta noche, se sentirá confundido cuando se comuniquen los aspectos de Mercurio nebulosos Neptuno. Este último es el rey de los mensajes ocultos sutiles, multiplicando la importancia y la cantidad de mensajes que recibe hoy.`,
        }
    },
}
export const tarot_es = {
    0: `Hoy, eliges tomar un enfoque más superficial en tus relaciones con los demás, readerName. Aunque no tienes motivo para quejarte de tu vida social satisfactoria, bajo la influencia de la Emperatriz y el Loco, te sientes tentado a poner la cantidad por encima de la calidad ... Este enfoque de "mariposa social" está muy bien si estás buscando relaciones sin ataduras, pero frustrante si necesita estabilidad. Tienes tanta confianza y motivación en el trabajo que celebrarás reunión tras reunión sin sentirte ni un poco cansado o poco entusiasta. La combinación del Diablo y la Emperatriz significa que tienes mucha fe en tus planes. Podrás avanzar para alcanzar objetivos fijos. Solo un poco de diplomacia en su trato con los demás y lo hará aún mejor.`,
    3: `En lo que se refiere a su vida emocional, hoy se siente como si finalmente hubiera unido todos los pedazos del rompecabezas que se sumarán a las relaciones duraderas. El Emperador y el Juicio ejercen su considerable influencia de modo que el tiempo que pasas con los demás es muy gratificante y te muestra que puedes confiar en tus amistades. Todos los que encuentren hoy querrán quedarse. En el ámbito profesional, usted será la encarnación de la rigidez, una consecuencia del efecto combinado del Emperador y la Justicia. Nada escapará a su ojo de águila: notará el error más mínimo, no tolerará ningún signo de debilidad. Y eso está muy bien, siempre que pueda, de vez en cuando, admitir haber cometido un error usted mismo. Entonces no tome una posición demasiado rígida, no sea farisaico. En cambio, trata de ser tolerante y escuchar lo que otros tienen que decir.`,
    6: `Estarás en dos mentes hoy. Por un lado, quieres estar solo y meditar (la influencia del Ermitaño); por el otro, deseas expresar abiertamente tu amor (como sugiere el Sol). Como cuestión de hecho, querido lectorNombre, esta combinación de cartas te dice que te beneficiarías al salir de tu propio mundo y abrirse a los demás. Aunque no es tu estilo hacer declaraciones apasionadas, serás capaz de transmitir la sinceridad y la profundidad de tus sentimientos. En el trabajo, la combinación de Judgment y el Ermitaño se suma a una atmósfera sombría: sientes como si tuvieras grandes dificultades para convertir tus ambiciones en realidad. Es cierto que los eventos que escapan a su control pueden obstaculizar sus planes o limitar el impacto de sus propuestas. No le faltan ideas, pero no se reciben tan bien como espera. No pierdas el corazón.`,
    9: `Hoy la rueda proverbial gira y te lleva el maravilloso movimiento de la Rueda de la Fortuna en asociación con el Loco amante de la libertad. Su vida social se enriquece con nuevas amistades y encuentros románticos, y estos no interfieren con su independencia en el corazón y la mente. Eres tan libre como el aire y tan alegre como un pájaro cantor: eres la encarnación del optimismo y el entusiasmo, ¡readerName! En el ámbito profesional, encontrarás que todo se está uniendo para ti. Sin duda, la influencia positiva que el Sol ejerce sobre la Rueda de la Fortuna tiene algo que ver con eso. Un verdadero torbellino de oportunidades te está subiendo vertiginosamente, y de repente te das cuenta de que tienes más libertad y autonomía para satisfacer tu sensación de independencia y creatividad. No puede haber ninguna duda de que su carrera está mejorando. Quién sabe, puede haber una promoción en la tienda! Son todas buenas noticias hoy. ¡Sólo déjate llevar!`,
    12: `¡Estás ardiendo hoy, readerName! Con el Demonio y el Mundo abanicando las llamas, anhelas el lado vaporoso del amor. Una feroz sensualidad recorre tus venas y quieres pasión sobre todo. Buscas sentimientos extremos: deseo, celos, éxtasis, a expensas del romance. ¡Será mejor que esperes que tu pareja se sienta de la misma manera! En el frente laboral, la atmósfera es eléctrica y la situación es desconcertante ... Bajo la influencia combinada del Demonio y el Ahorcado, adoptas un enfoque provocador para forzar una reacción de tus colaboradores, pero las cosas se vuelven agresivas. Hay comentarios cortantes y respuestas hirientes en todos lados, sin que nadie esté preparado para admitir sus errores. El orgullo y los sentimientos fuertes dominan demasiado: distanciate si no quieres decir o hacer algo que no puedas recuperar ...`
}


// WEBPACK FOOTER //
// ./src/utils/horoscope_es.js